import { Alert, Snackbar } from '@mui/material';
import React from 'react';


function WidgetSnackbar(message) {
  const [open, setOpen] = React.useState(false);
  const [error, setError] = React.useState(false);
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };
  const handleOpen = (err = false) => { setOpen(true); setError(err) };

  return [(
    <>
      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
        <Alert onClose={handleClose} severity={error ? "error" : "success"} variant="filled" sx={{ width: '100%' }}>
          {message}
        </Alert>
      </Snackbar>
    </>
  ), handleOpen];
}

export default WidgetSnackbar;